import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchSegments, onSetEditSegment, selectSegmentState, setAction } from "../redux/slices/segmentSlice"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { ApiStatus } from "../types/api/status"
import { SegmentAPI } from "../apis/SegmentAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { Segment } from "../types/slices/segmentType"

export const useSegmentStore = () => {

    const dispatch = useDispatch()
    const { segments, editSegment, status, action } = useSelector(selectSegmentState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getSegments = async (data?:any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SegmentAPI.list(idcompany, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(onFetchSegments(detail))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createSegment = async (data:any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SegmentAPI.create({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const updateSegment = async (idsegment:number, data:any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SegmentAPI.update(idsegment, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteSegment = async (idsegment: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await SegmentAPI.delete(idsegment)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setEditSegment = (segment:Segment) => {
        try {
            dispatch(onSetEditSegment(segment))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionSegment = (action:string) => {
        try {
            dispatch(setAction(action))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        segments,
        editSegment,
        status,
        action,
        getSegments,
        createSegment,
        updateSegment,
        deleteSegment,
        setEditSegment,
        setActionSegment
    }
}